import './RowOrder.css';
import { createRuntimeFn as _7a468 } from '@vanilla-extract/recipes/createRuntimeFn';
export var disabledNonTargetRow = '_or8s44-3-5-0';
export var dndHandle = _7a468({defaultClassName:'_or8s41-3-5-0',variantClassNames:{disabled:{true:'_or8s42-3-5-0',false:'_or8s43-3-5-0'}},defaultVariants:{},compoundVariants:[]});
export var rowDndOverlay = '_or8s40-3-5-0';